import React from 'react';
// components
import NavBar from '../element/NavBar';

const AnketaPage = () => (
  <>
    <NavBar />
    <section className='anketaPage'>
      <div className='bannerBox'>
        <img width={640} alt='banner' src='/Images/anketa/anketa_partners.jpg' />
      </div>
      <iframe
        width='100%'
        height='100%'
        src='https://docs.google.com/forms/d/e/1FAIpQLSfQFp1Kd1WWlS2YenNF9UX4spGYUDY4N9hn7U1RTVq9OSSXWA/viewform?embedded=true'
      >
        Завантаження…
      </iframe>
    </section>
  </>
);

export default AnketaPage;
